import React, { useCallback } from "react";
import "./App.css";

const APP_STORE_URL = "https://apps.apple.com/us/app/pnusa/id6762349393";

const App = () => {
  const handleOpenAppStore = useCallback(() => {
    if (typeof window === "undefined") {
      return;
    }

    window.open(APP_STORE_URL, "_blank", "noopener,noreferrer");
  }, []);

  return (
    <main className="shutdown-redirect-page">
      <section className="shutdown-redirect-card">
        <p className="shutdown-redirect-badge">서비스 종료</p>
        <h1>PNUSA 웹 서비스가 종료되었습니다.</h1>

        <p>App Store 이동 버튼을 눌러 앱으로 이동해 주세요.</p>
        <p>
          현재 App Store 버전에서 일시적인 서버 오류가 발생해 수정 버전을
          업데이트 후 심사 중입니다. 조금만 기다려주시면 앱을 다시 사용하실 수
          있습니다.
        </p>
        <p>
          iOS 기능 안정화 작업이 끝나는 대로 Android 출시 준비를 진행하겠습니다.
        </p>

        <section className="shutdown-notice-box" aria-live="polite">
          <h2>공지</h2>
          <p className="shutdown-notice-strong">PNUSA 앱 업데이트 안내</p>
          <p>
            PNUSA Appstore 서버 오류가 해결되어 현재 정상적으로 이용
            가능합니다.
          </p>
          <p>
            현재 서버 오류가 수정된 최신 버전이 업데이트되었습니다.
            앱을 업데이트하시면 정상적으로 이용하실 수 있습니다.
            원활한 이용을 위해 지금 바로 최신 버전으로 업데이트해주시기
            바랍니다. 감사합니다.
          </p>
        </section>

        <div className="shutdown-action-row">
          <button
            type="button"
            className="shutdown-redirect-link"
            onClick={handleOpenAppStore}
          >
            App Store에서 PNUSA 열기
          </button>
        </div>
      </section>
    </main>
  );
};

export default App;
